import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";

export default injectIntl((props) => {
  const { data, isFailedTable = false, intl } = props;
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    // Tạo danh sách cột cơ bản
    let baseColumns = [
      {
        Header: <IntlMessages id="pages.product-name" />,
        accessor: "name",
        minWidth: 150,
      },
      {
        Header: <IntlMessages id="table.import.sku" />,
        accessor: "sku",
      },
      {
        Header: <IntlMessages id="table.import.barcode" />,
        accessor: "barcode",
      },
      {
        Header: <IntlMessages id="pages.category" />,
        accessor: "category",
      },
      {
        Header: <IntlMessages id="table.import.recommend" />,
        accessor: "bestter",
      },
      {
        Header: <IntlMessages id="product.price" />,
        accessor: "price",
      },
      {
        Header: <IntlMessages id="product.promotion-price" />,
        accessor: "price_sale",
      },
      {
        Header: <IntlMessages id="table.import.apply_promotion" />,
        accessor: "active_sale",
      },
      {
        Header: <IntlMessages id="table.import.image" />,
        accessor: "image",
      },
      {
        Header: <IntlMessages id="table.import.hidden" />,
        accessor: "softHide",
      },
    ];

    // Nếu đây là bảng lỗi, thêm một cột "Lý do lỗi"
    if (isFailedTable) {
      baseColumns.push({
        Header: <IntlMessages id="table.import.error_reason" />,
        accessor: "_errorMessage", // Lấy từ dữ liệu đã chuẩn bị
        minWidth: 200,
        // Thêm style cho cột này để nổi bật
        style: {
          fontWeight: "bold",
          whiteSpace: "pre-wrap", // Để xuống dòng nếu lỗi quá dài
        },
      });
    }

    setState({
      columns: [
        {
          Header: (
            <div
              style={{ textAlign: "center", color: "red", fontWeight: "bold" }}
            >
              <IntlMessages id="table.import.failed" />: {data.length}
              <span
                style={{
                  textAlign: "center",
                  color: "blue",
                  fontWeight: "bold",
                }}
              >
                {" "}
                - <IntlMessages id="table.import.success" />:{" "}
                {props.dataSuccess.length}{" "}
              </span>
            </div>
          ),
          columns: baseColumns,
        },
      ],
    });
  }, [isFailedTable]); // Thêm isFailedTable vào dependency array

  const getTrProps = (state, rowInfo, column) => {
    // Chỉ áp dụng style đỏ nếu đây là bảng lỗi
    if (isFailedTable) {
      return {
        style: {
          color: "red",
          backgroundColor: "#fff0f0",
        },
      };
    }
    return {};
  };

  return (
    <ReactTable
      data={data}
      columns={state.columns}
      getTrProps={getTrProps}
      defaultPageSize={10}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
});

// export default (props) => {
//     // console.log(props);
//     const [state, setState] = useState({
//         columns: [],
//     });

//     useEffect(() => {
//         setState({
//             ...state,
//             columns: [
//                 {
//                     columns: [
//                         {
//                             Header: 'Tên sản phẩm',
//                             accessor: 'name',
//                             minWidth: 150,
//                         },
//                         {
//                             Header: 'Mã SKU',
//                             accessor: 'sku',
//                             minWidth: 150,
//                         },
//                         {
//                             Header: 'Barcode',
//                             accessor: 'barcode',
//                             minWidth: 150,
//                         },
//                         {
//                             Header: 'Danh mục sản phẩm',
//                             accessor: 'category',
//                             minWidth: 100,
//                         },
//                         {
//                             Header: 'ID Danh mục sản phẩm',
//                             accessor: 'category_id',
//                             minWidth: 100,
//                         },
//                         {
//                             Header: 'Khuyên dùng',
//                             accessor: 'bester',
//                             minWidth: 100,
//                         },
//                         {
//                             Header: 'Giá bán',
//                             accessor: 'price',
//                             minWidth: 100,
//                         },
//                         {
//                             Header: 'Giá khuyến mãi',
//                             accessor: 'price_sale',
//                             minWidth: 150,
//                         },
//                         {
//                             Header: 'Active Sale',
//                             accessor: 'active_sale',
//                             minWidth: 100,
//                         },
//                         {
//                             Header: 'Hình ảnh',
//                             accessor: 'image',
//                             minWidth: 260,
//                         },
//                     ],
//                 },
//             ],
//         });
//     }, []);

//     return (
//         <ReactTable
//             defaultPageSize={10}
//             data={props.data}
//             columns={state.columns}
//             minRows={0}
//             showPageJump={false}
//             showPageSizeOptions={true}
//             PaginationComponent={Pagination}
//             NoDataComponent={() => null}
//         />
//     );
// };
